import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Table from "components/Table/CustomTable";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import CustomSelect from "components/CustomSelect/CustomSelect";
import { makeStyles } from "@material-ui/core/styles";
import { getMakes, getModels } from "views/Services/MakesModelsService";
import { useTranslation } from "react-i18next";
import EditIcon from "@material-ui/icons/Edit";
import { Tooltip } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import styleMain from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";

const useStyles = makeStyles(styles);
const useStylesMain = makeStyles(styleMain);

export default function MakesModels() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const classesMain = useStylesMain();
  const history = useHistory();

  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [makes, setMakes] = useState([]);
  const [selectedMake, setSelectedMake] = useState("");
  const [models, setModels] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const styleButton = {
    cursor: "pointer",
    padding: "0px !important",
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    let yearsArr = [];
    for (let i = -1; i <= 54; i++) {
      yearsArr.push({
        value: `${currentYear - i}`,
        label: `${currentYear - i}`,
      });
    }
    setYears(yearsArr);
  }, []);

  useEffect(() => {
    if (selectedYear) {
      fetchMakes(selectedYear);
    }
  }, [selectedYear]);

  useEffect(() => {
    if (selectedMake) {
      fetchModels(selectedMake);
    }
  }, [selectedMake]);

  const fetchMakes = async (year) => {
    const result = await dispatch(getMakes({ year }));
    if (result.payload && result.payload.data) {
      setMakes(result.payload.data);
    }
  };

  const fetchModels = async (makeId) => {
    setLoading(true);
    const result = await dispatch(getModels({ makeId }));
    if (result.payload && result.payload.data) {
      setModels(result.payload.data);
      setTotalRows(result.payload.data.length);
    }
    setLoading(false);
  };

  const handleChangePage = (currentPage) => {};

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
    setSelectedMake("");
    setModels([]);
  };

  const handleMakeChange = (e) => {
    setSelectedMake(e.target.value);
  };

  const handleAddMake = () => {
    history.push("/admin/vehicleMake");
  };

  const handleAddModel = () => {
    history.push("/admin/vehicleModel");
  };

  const handleEditMake = (makeId) => {
    history.push(`/admin/vehicleMake/${makeId}`);
  };

  const handleEditModel = (modelId) => {
    history.push(`/admin/vehicleModel/${modelId}`);
  };

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer
            style={{ padding: "20px 0px 40px 0px" }}
            justify="center"
          >
            <GridContainer>
              <GridItem xs={12} md={12}>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Card>
                    <CardHeader>
                      <div className={classesMain.title + " " + classesMain.black}>
                        {t("makesModels.title") || "Makes and Models"}
                      </div>
                      <GridContainer></GridContainer>
                    </CardHeader>
                    <CardBody>
                      <GridContainer>
                        <GridItem xs={0} sm={0} md={6}></GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                          <Button
                            style={{ float: "right", marginLeft: 8 }}
                            variant="green"
                            onClick={handleAddMake}
                          >
                            Add New Make
                          </Button>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                          <Button
                            style={{ float: "right" }}
                            variant="green"
                            onClick={handleAddModel}
                          >
                            Add New Model
                          </Button>
                        </GridItem>
                      </GridContainer>
                      <GridContainer>
                        <GridItem xs={0} sm={0} md={6}></GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                          <CustomSelect
                            labelText="Year"
                            menuItems={years}
                            inputProps={{
                              name: "year",
                              value: selectedYear,
                              onChange: handleYearChange,
                            }}
                            formControlProps={{ fullWidth: true }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                          <CustomSelect
                            labelText="Make"
                            menuItems={makes.map((make) => ({
                              value: make.id,
                              label: make.name,
                            }))}
                            inputProps={{
                              name: "make",
                              value: selectedMake,
                              onChange: handleMakeChange,
                            }}
                            formControlProps={{ fullWidth: true }}
                          />
                        </GridItem>
                      </GridContainer>
                      <Table
                        tableHead={[
                          "Vehicle Make",
                          "Vehicle Model",
                          "Risk",
                          "Edit Make",
                          "Edit Model",
                        ]}
                        rowsPerPage={10}
                        totalRows={totalRows}
                        changePage={handleChangePage}
                        loading={loading}
                        tableData={models.map((model) => [
                          model.make_name,
                          `${model.model_name} ${model.trim || ""} ${
                            model.year
                          }`,
                          model.surcharge || "",
                          <GridItem
                            onClick={() => handleEditMake(model.make_id)}
                            md={2}
                            style={styleButton}
                          >
                            <Tooltip title="Edit Make" placement="top" arrow>
                              <EditIcon
                                style={{ color: "#13816F" }}
                                fontSize="small"
                              ></EditIcon>
                            </Tooltip>
                          </GridItem>,
                          <GridItem
                            onClick={() => handleEditModel(model.model_id)}
                            md={2}
                            style={styleButton}
                          >
                            <Tooltip title="Edit Model" placement="top" arrow>
                              <EditIcon
                                style={{ color: "#13816F" }}
                                fontSize="small"
                              ></EditIcon>
                            </Tooltip>
                          </GridItem>,
                        ])}
                      />
                    </CardBody>
                  </Card>
                </GridItem>
              </GridItem>
            </GridContainer>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
